export default {
  estaCadastrandoCartao: false,
  formularioFormaDePagamentoCliente: {
    pagamento_automatico: false,
    forma_pagamento_selecionado_padrao: '',
    forma_pagamento_idselecionado: '',
    cartao_selecionado_padrao: '',
    filho: ''
  }
}
